<template>
  <div v-if="job.user" class="card-body">

    <div class="d-flex justify-content-start cursor-pointer" style="width:100%">
      <div>
        <div class="d-flex flex-column pe-3">
          <div>
            <img onerror="javascript:this.src='/images/avatar/user.png'" :src="`/images/avatar/${job.user.avatar}`" alt=""
              width="50" height="50" class="user-avatar">
          </div>
          <CustomerRating class="pt-1" :rating="job.user.rating" />
          <div class="job-panel__username fs-12px">
            {{ job.user.name }}
          </div>
        </div>
      </div>

      <div class="d-flex flex-column justify-content-between" style="width:100%">
        <div class="d-flex flex-row justify-content-between">
          <div>
            <h4 class="card-title"><a class="task-href" @click="$router.push(`/job/${job.id}/show`);">
                {{ job.title }}</a></h4>
          </div>
          <div>
            <span class="badge bg-info fs-16px cursor-pointer">{{ job.price }}<small
                class="fs-6 fw-normal ps-1">руб.</small></span>
          </div>
        </div>

        <small class="text-gray-700">{{ job.updated_at }}
          <b class="pe-2">ID{{ job.id }}</b>
          <a :href="job.link" target="_blank" class="pe-2">{{ getDomain(job.link) }}</a>
        </small>

        <div class="card-text pt-2">
          <div class="row">
            <div class="col-xl-6 col-md-12 col-sm-12 col-12">
              <table>
                <tr>
                  <td style="min-width:150px">Категория:</td>
                  <td>{{ job.type_desc }}</td>
                </tr>
                <tr>
                  <td style="min-width:150px">Выполнено:</td>
                  <td style="white-space:nowrap">{{ job.done }}</td>
                </tr>
              </table>
            </div>
            <div class="col-xl-6 col-md-12 col-sm-12 col-12">
              <table>
                <tr>
                  <td style="min-width:150px">Время выполнения:</td>
                  <td style="white-space:nowrap">{{ job.time_work_desc }}</td>
                </tr>
                <tr>
                  <td style="min-width:150px">Время проверки:</td>
                  <td style="white-space:nowrap">{{ job.time_check_desc }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JobPanel',
  props: ['job'],
  data() {
    return {
    }
  },
  methods: {
    getDomain(url) {
      //eslint-disable-next-line
      let pattern = /^(?:https?:\/\/)?(?:[^@\/\n]+@)?(?:www\.)?([^:\/\n]+)/
      let resp = pattern.exec(url)
      return resp[1]
    }
  }
}
</script>



<style>
.user-avatar {
  object-fit: cover;
  border-radius: 50rem !important;
}

.job-panel__username {
  width: 50px;
  height: 20px;
  overflow: hidden;
  text-align: center;
  padding-top: 3px;
}

.job-panel__username::first-letter {
  text-transform: uppercase;
}
</style>